import React from 'react';
import { Config, BUILD_TYPE } from 'utils/webappConfig';

class Hotjar extends React.PureComponent {

  constructor(props) {
    super(props);
    const APP_ID = Config.builds[BUILD_TYPE].hotjar_app_id;
    /* eslint-disable */
    (function(h,o,t,j,a,r){
      h.hj=h.hj||function(){(h.hj.q=h.hj.q||[]).push(arguments)};
      h._hjSettings={hjid:APP_ID,hjsv:6};
      a=o.getElementsByTagName('head')[0];
      r=o.createElement('script');r.async=1;
      r.src=t+h._hjSettings.hjid+j+h._hjSettings.hjsv;
      a.appendChild(r);
    })(window,document,'https://static.hotjar.com/c/hotjar-','.js?sv=');
  }

  render() {
    return null;
  }
}

export default Hotjar;
